import { useState } from 'react';

import _ from 'lodash';

import { FadeInAnimation } from '../../shared/index';

import PropTypes from 'prop-types';

import { Formik, Field as FormikField } from 'formik';

import { TextField } from 'formik-mui';

import * as Yup from 'yup';

import FormHelperText from '@mui/material/FormHelperText';

import Phone from '@mui/icons-material/Phone';
import PhoneIphone from '@mui/icons-material/PhoneIphone';
import MailOutline from '@mui/icons-material/MailOutline';

import { Button, Image } from '../../shared';

import useResponsive from '../../../../utils/responsive';

import ContactAgentDialog from '../../contact-agent-dialog/contact-agent-dialog.component';

import { agentDomain } from '../../../domain';

const agentContactFormInitialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: '',
};

const agentContactFormValidationSchema = Yup.object({
    firstName: Yup.string('').required('First name is required'),
    lastName: Yup.string('').required('Last name is required'),
    email: Yup.string('').email('Enter a valid email').required('Email is required'),
    phone: Yup.string('')
        .matches(/^[0-9,+]*$/, 'Phone number is invalid')
        .min(9, 'Phone number is too short (minimum 9)')
        .max(15, 'Phone number is too long (maximum 15)')
        .required('Phone number is required'),
    message: Yup.string('').required('Message is required'),
});

const RoomTypeAgent = ({ agentDetails, selectedRoomType }) => {
    const { isMobile, isSmallTablet, isTablet } = useResponsive();
    const [submitError, setSubmitError] = useState(null);
    const [successfullySubmitted, setSuccessfullySubmitted] = useState(null);
    const agentId = _.get(agentDetails, 'id');
    const [isOpenMobileDialog, setIsOpenMobileDialog] = useState(false);
    const roomTypeId = _.get(selectedRoomType, 'id');
    const inquiryMessageDefault = `Please send me more information about the ${_.get(
        selectedRoomType,
        'description',
    )}, ${_.get(selectedRoomType, 'buildingName')}.`;

    agentContactFormInitialValues.message = inquiryMessageDefault;

    const onMobileSendClick = () => {
        setIsOpenMobileDialog(true);
    };

    const onSubmit = async ({ firstName, lastName, phone, email, message }, { setSubmitting }) => {
        setSubmitting(true);
        try {
            agentDomain.submitAgentInquiry(
                agentId,
                roomTypeId,
                firstName,
                lastName,
                phone,
                email,
                message,
            );
            setSubmitError(null);
            setSuccessfullySubmitted(true);
        } catch (error) {
            setSubmitError(error.message);
            setSuccessfullySubmitted(false);
        } finally {
            setSubmitting(false);
        }
    };

    const contactForm = () => {
        return (
            <>
                {!successfullySubmitted && (
                    <Formik
                        initialValues={agentContactFormInitialValues}
                        validationSchema={agentContactFormValidationSchema}
                        onSubmit={onSubmit}
                        validateOnBlur
                        validateOnChange={false}
                    >
                        {({
                            submitForm,
                            isSubmitting,
                            touched,
                            errors,
                            handleChange,
                            handleBlur,
                            handleReset,
                            handleSubmit,
                        }) => (
                            <form onReset={handleReset} onSubmit={handleSubmit}>
                                <div className='room-type-agent-name-input-container'>
                                    <FormikField className="room-type-agent-first-name-field"
                                        component={TextField}
                                        required
                                        name="firstName"
                                        id="firstName"
                                        type="text"
                                        label="Your Name"
                                        variant="outlined"
                                        color="secondary"
                                        helperText={touched.firstName ? errors.firstName : ''}
                                        error={touched.firstName && !!errors.firstName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        fullWidth
                                    />
                                    <FormikField className="room-type-agent-last-name-field"
                                        component={TextField}
                                        required
                                        name="lastName"
                                        id="lastName"
                                        type="text"
                                        label="Your Surname"
                                        variant="outlined"
                                        color="secondary"
                                        helperText={touched.lastName ? errors.lastName : ''}
                                        error={touched.lastName && !!errors.lastName}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        fullWidth
                                    />
                                </div>

                                <FormikField className="room-type-agent-field"
                                    component={TextField}
                                    required
                                    name="email"
                                    id="email"
                                    type="email"
                                    label="Email"
                                    variant="outlined"
                                    color="secondary"
                                    helperText={touched.email ? errors.email : ''}
                                    error={touched.email && !!errors.email}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                />

                                <FormikField className="room-type-agent-field"
                                    component={TextField}
                                    required
                                    name="phone"
                                    id="phone"
                                    type="tel"
                                    label="Phone"
                                    variant="outlined"
                                    color="secondary"
                                    helperText={touched.phone ? errors.phone : ''}
                                    error={touched.phone && !!errors.phone}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                />

                                <FormikField className="room-type-agent-field"
                                    component={TextField}
                                    required
                                    name="message"
                                    id="message"
                                    multiline
                                    type="text"
                                    label="Please send me more information about the"
                                    variant="outlined"
                                    color="secondary"
                                    helperText={touched.message ? errors.message : ''}
                                    error={touched.message && !!errors.message}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    fullWidth
                                />

                                <br />

                                <FormHelperText error>{submitError}</FormHelperText>

                                <Button
                                    className="room-type-agent-submit-button"
                                    variant="contained"
                                    color="primary"
                                    isLoading={isSubmitting}
                                    onClick={submitForm}
                                    id="sign-up-form"
                                    type="submit"
                                >
                                    Send Message
                                </Button>

                            </form>
                        )}
                    </Formik>
                )}
                {successfullySubmitted && (
                    <div className='room-type-agent-thank-you-message-container'>
                        <h4>Thanks for Getting in Touch!</h4>
                        <p>Your inquiry has been sent and the agent should contact you ASAP</p>
                    </div>
                )}
            </>
        );
    };

    const renderAgentDetails = () => {        
        const classAgentSpacing = isTablet ? 'main-grid-item main-grid-sm-5' : 'main-grid-item main-grid-sm-3';
        const agentImgSrc = _.isEmpty(_.get(agentDetails, 'images'))
            ? '/assets/images/avatar.png'
            : _.get(agentDetails, 'images[0]');

        return (
            <div className='main-grid-container main-grid-spacing-xs-3'>

                <div className={classAgentSpacing}>
                    <Image
                        className="room-type-agent-image"
                        src={agentImgSrc}
                        alt="agentPhoto"
                        width={130}
                        height={190}
                        isOldImage
                    />
                </div>

                <div className='main-grid-item main-grid-sm-5'>

                    <h5 className='room-type-agent-name'>
                        {_.get(agentDetails, 'firstName')} {_.get(agentDetails, 'lastName')}
                    </h5>

                    <div className='room-type-agent-icon-container'>
                        <Phone className="room-type-agent-phone-icon" />
                        <h6>{_.get(agentDetails, 'officeNumber')}</h6>
                    </div>

                    <div className='room-type-agent-icon-container'>
                        <PhoneIphone className="room-type-agent-phone-iphone-icon" />
                        <h6>{_.get(agentDetails, 'mobileNumber')}</h6>
                    </div>

                    <div className='room-type-agent-icon-container'>
                        <MailOutline className="room-type-agent-mail-outline-icon" />
                        <h6>{_.get(agentDetails, 'email')}</h6>
                    </div>

                </div>

            </div>
        );
    };

    return (
        <FadeInAnimation>
            <div id="contact-agent-section">
                <h3 className='room-type-agent-header3'>Contact Agent</h3>
                <div className='main-grid-container'>
                    {!(isMobile || isSmallTablet) && (
                        <div className='main-grid-item main-grid-sm-5'>
                            {contactForm()}
                        </div>
                    )}
                    <div className='main-grid-item main-grid-sm-6'>
                        {renderAgentDetails()}
                    </div>
                </div>

                {(isMobile || isSmallTablet) && (
                    <Button onClick={onMobileSendClick} className="room-type-agent-mobile-submit-button">
                        Send Message
                    </Button>
                )}

                <ContactAgentDialog isOpen={isOpenMobileDialog} setIsOpen={setIsOpenMobileDialog} />

            </div>

        </FadeInAnimation>
    );
};

export default RoomTypeAgent;

RoomTypeAgent.propTypes = {
    agentDetails: PropTypes.object,
    selectedRoomType: PropTypes.object,
};
